import { css } from '@emotion/react';
import { forwardRef } from 'react';
import { theme } from 'styles/theme';

export const Textarea = forwardRef(
	(
		{
			placeholder,
			width,
			onChange,
			onBlur,
			name,
			error,
			rows,
		}: {
			placeholder?: string;
			width?: number;
			name?: string;
			onChange: (value: any) => void;
			onBlur: (value: any) => void;
			error?: boolean;
			rows?: number;
		},
		ref,
	) => {
		// console.log(error);

		return (
			<div
				css={css`
					width: 100%;
				`}
			>
				<textarea
					ref={ref}
					name={name}
					onChange={onChange}
					onBlur={onBlur}
					id={name}
					rows={rows ? rows : 3}
					type="text"
					placeholder={placeholder}
					css={css`
						border: 1px solid #d4d5de;
						border-radius: 8px;
						width: ${width ? width + 'px' : '100%'};
						padding: 12px;
						font-size: 14px;
						line-height: 20px;

						::placeholder {
							color: #8c8fa6;
						}

						&:focus {
							outline: none;
							box-shadow: 0 0 0 2px ${theme.color.primary['400']};
							border-color: transparent;
						}

						${!!error &&
						css`
							border-color: #ff6767;
						`}
					`}
				/>
			</div>
		);
	},
);
